import { render, staticRenderFns } from "./UVS.vue?vue&type=template&id=3ee800ef&scoped=true"
import script from "./UVS.vue?vue&type=script&lang=js"
export * from "./UVS.vue?vue&type=script&lang=js"
import style0 from "./UVS.vue?vue&type=style&index=0&id=3ee800ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee800ef",
  null
  
)

export default component.exports